import { useState, useRef, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { FaSortUp, FaSortDown } from 'react-icons/fa';

const CandidateTable = ({ candidates }) => {
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const tableRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tableRef.current && !tableRef.current.contains(event.target)) {
        setSortField(null);
        setSortOrder('asc');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedCandidates(candidates.map(candidate => candidate.id));
    } else {
      setSelectedCandidates([]);
    }
  };

  const handleRowCheckboxChange = (candidateId) => {
    setSelectedCandidates((prevSelected) =>
      prevSelected.includes(candidateId)
        ? prevSelected.filter(id => id !== candidateId)
        : [...prevSelected, candidateId]
    );
  };

  const sortedCandidates = [...candidates].sort((a, b) => {
    if (!sortField) return 0;
    const aValue = a[sortField] || '';
    const bValue = b[sortField] || '';

    if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <Table bordered hover ref={tableRef}>
      <thead>
        <tr>
          <th>
            <input
              type="checkbox"
              onChange={handleSelectAll}
              checked={selectedCandidates.length === candidates.length}
            />
          </th>
          <th onClick={() => handleSort('name')}>Name {sortField === 'name' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('email')}>Email {sortField === 'email' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('phone')}>Phone {sortField === 'phone' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('title')}>Title {sortField === 'title' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('cvProcessed')}>CV Processed {sortField === 'cvProcessed' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('source')}>Source {sortField === 'source' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('education')}>Education {sortField === 'education' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
          <th onClick={() => handleSort('workExperience')}>Work Experience {sortField === 'workExperience' && (sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />)}</th>
        </tr>
      </thead>
      <tbody>
        {sortedCandidates.map(candidate => (
          <tr key={candidate.id}>
            <td>
              <input
                type="checkbox"
                checked={selectedCandidates.includes(candidate.id)}
                onChange={() => handleRowCheckboxChange(candidate.id)}
              />
            </td>
            <td>{candidate.name}</td>
            <td>{candidate.email}</td>
            <td>{candidate.phone}</td>
            <td>{candidate.title}</td>
            <td>{candidate.cvProcessed ? '✓' : '✗'}</td>
            <td>{candidate.source}</td>
            <td>{candidate.education}</td>
            <td>{candidate.workExperience}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default CandidateTable;
